import { provideZoneChangeDetection } from "@angular/core";
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// AA-12: MetricOrNaPipe (y cualquier otro uso de DecimalPipe/CurrencyPipe con locale 'es')
// lanzaba NG0701 "Missing locale data for the locale es" en el navegador real de cualquier
// usuario -- nunca se había registrado el locale español en toda la app. Según el propio
// comentario de MetricOrNaPipe, ese error aborta esa pasada de change detection y deja el resto
// del template sin actualizar, no solo esa métrica. Nunca se detectó porque ningún test corría
// en CI hasta ahora (ver AA-12).
registerLocaleData(localeEs);

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).catch(err => console.error(err));
